export default function transformHref({ slug, type }) {
	if (type === "category") {
		return `/category/${slug}/`;
	}

	if (type === "collection") {
		return `/collection/${slug}/`;
	}

	if (type === "campaign" && slug !== "gifting") {
		return `/box-insider/${slug}/`;
	}

	return `/${slug}/`;
}
